import Base from './Base';

export default class Tag extends Base {
    constructor(item) {
        super(item);

        if (!this.id) this.id = item.tag_id;
    }

    get filters() {
        return {
            filtersList: [
                {
                    filters: [
                        {
                            key: 'tag',
                            operator: 'is_any',
                            value: this.id,
                        }
                    ]
                }
            ],
        }
    }
}
